import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, Space, Typography, Button, message } from 'antd';
import { superadminApi } from '../../services/superadminApi';

const { Title, Text } = Typography;

const Companies = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const data = await superadminApi.listCompanies();
      setItems(data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const approve = async (slug) => {
    try {
      await superadminApi.approveCompany(slug);
      message.success('Company approved');
      await load();
    } catch (e) { message.error(e.message || 'Failed to approve'); }
  };

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Slug', dataIndex: 'slug', key: 'slug' },
    { title: 'Owner', key: 'owner', render: (_, r) => `${r.ownerName} <${r.ownerEmail}>` },
    { title: 'Plan', dataIndex: 'plan', key: 'plan' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'active' ? 'green' : s === 'pending' ? 'orange' : 'red'}>{s}</Tag> },
    { title: 'Actions', key: 'actions', render: (_, r) => (
      <Space>
        {r.status !== 'active' && (
          <Button size="small" type="primary" onClick={() => approve(r.slug)}>Approve</Button>
        )}
      </Space>
    ) },
  ];

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div className="flex items-center justify-between">
          <Title level={3} className="!mb-0">Companies</Title>
        </div>
        <Text type="secondary">Registered companies awaiting approval and active ones.</Text>
        <Table rowKey={(r) => r._id || r.slug} loading={loading} columns={columns} dataSource={items} />
      </Space>
    </Card>
  );
};

export default Companies;
